module.exports = __webpack_public_path__ + "img/banner.d9e3d26c.png";